import { render } from "./overlay-drag.vue?vue&type=template&id=8ad87dc8"
import script from "./overlay-drag.vue?vue&type=script&lang=js"
export * from "./overlay-drag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__